import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const SingleLeftArrowIcon = forwardRef<SVGSVGElement, IconProps>(function SingleLeftArrowIcon(
  { color = '', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0833 8.0163C14.2384 8.17136 14.2384 8.42276 14.0833 8.57782L10.6582 12.0029L14.0833 15.4281C14.2384 15.5831 14.2384 15.8345 14.0833 15.9896C13.9283 16.1446 13.6768 16.1446 13.5218 15.9896L9.8159 12.2837C9.66084 12.1286 9.66084 11.8772 9.8159 11.7222L13.5218 8.0163C13.6768 7.86123 13.9283 7.86123 14.0833 8.0163Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3662 7.73345C14.6774 8.04472 14.6774 8.54939 14.3662 8.86066L11.2239 12.0029L14.3662 15.1452C14.6774 15.4565 14.6774 15.9612 14.3662 16.2724C14.0549 16.5837 13.5502 16.5837 13.2389 16.2724L9.53306 12.5665C9.22179 12.2553 9.22179 11.7506 9.53306 11.4393L13.2389 7.73345C13.5502 7.42218 14.0549 7.42218 14.3662 7.73345ZM10.3309 11.7729L10.1008 12.0029L10.3309 12.233C10.234 12.0955 10.234 11.9104 10.3309 11.7729Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
